import { render, staticRenderFns } from "./ContentSelectionSundayResultsMobile.vue?vue&type=template&id=5b700508&scoped=true&"
import script from "./ContentSelectionSundayResultsMobile.vue?vue&type=script&lang=js&"
export * from "./ContentSelectionSundayResultsMobile.vue?vue&type=script&lang=js&"
import style0 from "./ContentSelectionSundayResultsMobile.vue?vue&type=style&index=0&id=5b700508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b700508",
  null
  
)

export default component.exports